// extracted by mini-css-extract-plugin
module.exports = {"logo":"styles_logo__w22sd","wordmark":"styles_wordmark__6aNvP"};